
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class AccountingPeriodDetailsDialog extends _Ext.EditorDialogBase<AccountingPeriodDetailsRow> {
        protected getFormKey() { return AccountingPeriodDetailsForm.formKey; }
        protected getIdProperty() { return AccountingPeriodDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return AccountingPeriodDetailsRow.localTextPrefix; }
        protected getService() { return AccountingPeriodDetailsService.baseUrl; }
        protected getDeletePermission() { return AccountingPeriodDetailsRow.deletePermission; }
        protected getInsertPermission() { return AccountingPeriodDetailsRow.insertPermission; }
        protected getUpdatePermission() { return AccountingPeriodDetailsRow.updatePermission; }

        protected form = new AccountingPeriodDetailsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
    }
}